import React from "react";
import { UserForm } from "../sub-components/form/user-form.component";

export const UserNewPage = () => {
  return <UserForm />;
};
